import type { Routes } from '@angular/router'

import { trackRedirectRoute } from '@framework/core/track-redirect-route'
import * as environment from '@framework/environment'
import { canMatchLoggedIn } from '@framework/modules/auth/matchers/logged-in.matcher'
import { redirectToLoginWithUrl } from '@framework/modules/auth/matchers/redirect-to-login-with-url'

import { countryCodeRedirectGuard } from '@framework/guards/country-code.guard'
import { verifyDeviceResolver } from '@framework/guards/verify-device.resolver'

import { LEGACY_REDIRECT_ROUTES } from './legacy-redirect.routes'

const COUNTRY_CODE_HANDLING_ROUTES: Routes = [
  ...(environment.PAGES_AFFILIATES
    ? [
        {
          path: 'affiliates',
          loadComponent: () =>
            import('@framework/modules/affiliate-program/components/affiliate-program/affiliate-program.component').then(
              c => c.AffiliateProgramComponent,
            ),
          data: {
            footer: 'full',
            header: false,
            title: `Affiliate Program | ${environment.siteName}`,
          },
        },
      ]
    : []),
  {
    path: 'login',
    loadChildren: () => import('@framework/modules/login/login.routes').then(m => m.LOGIN_ROUTES),
  },
]

export const APP_ROUTES: Routes = [
  ...LEGACY_REDIRECT_ROUTES.map(trackRedirectRoute),
  {
    path: 'deactivated',
    data: { header: false, footer: 'hidden', robots: 'noindex' },
    loadComponent: () =>
      import('@framework/modules/account-deactivated/account-deactivated.component').then(
        c => c.AccountDeactivatedComponent,
      ),
  },
  {
    path: 'password-reset',
    loadChildren: () =>
      import('@framework/modules/password-reset/password-reset.routes').then(m => m.PASSWORD_RESET_ROUTES),
  },
  {
    path: 'verify-device',
    loadChildren: () => import('@framework/modules/verify-device/verify-device.route').then(c => c.routes),
    data: { header: false, footer: 'hidden', robots: 'noindex' },
    resolve: { email: verifyDeviceResolver },
  },
  {
    path: '',
    data: { footer: 'hidden', robots: 'noindex' },
    canMatch: [canMatchLoggedIn],
    children: [
      {
        path: 'next',
        loadChildren: () => import('@framework/modules/member/member.routes').then(m => m.MEMBER_ROUTES),
      },
      {
        path: '**',
        redirectTo: 'next',
      },
    ],
  },
  {
    path: 'next',
    children: [
      {
        path: '**',
        canActivate: [redirectToLoginWithUrl],
        children: [],
      },
    ],
  },
  {
    path: 'signup',
    loadChildren: () => import('@framework/modules/signup/signup.routes').then(m => m.SIGNUP_ROUTES),
  },

  ...COUNTRY_CODE_HANDLING_ROUTES.map(route => ({
    ...route,
    canActivate: [countryCodeRedirectGuard],
  })),
  {
    path: ':cc',
    children: [...COUNTRY_CODE_HANDLING_ROUTES, { path: '', pathMatch: 'full', redirectTo: '/login' }],
  },
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
]
